// @mui material components
import Card from "@mui/material/Card";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";

// Authentication layout components
import CoverLayout from "layouts/authentication/components/CoverLayout";

// Images
// import bgImage from "assets/images/bg-reset-cover.jpeg";
import bgImage from "assets/images/bg-sign-in-basic.jpeg";
import { useNavigate, useParams } from "react-router-dom";
import { useCallback, useState } from "react";
import useLoading from "hooks/use-loading";
import { resetPassword } from "tutor/services/password-service";

function Cover() {
  const { setShowLoader } = useLoading();

  const [password, setPassword] = useState("");
  const [passwordHasError, setPasswordHasError] = useState(false);
  const [passwordErrorMessage, setPasswordErrorMessage] = useState("");

  const [confirmPassword, setConfirmPassword] = useState("");
  const [confirmHasError, setConfirmHasError] = useState(false);
  const [confirmErrorMessage, setConfirmErrorMessage] = useState("");

  const [responseHasError, setResponseHasError] = useState(false);
  const [responseErrorMessage, setResponseErrorMessage] = useState("");

  const onPasswordChangeHandler = (e) => {
    if (e.target.value.length === 0) {
      setPasswordHasError(true);
      setPasswordErrorMessage("Password is required");
    } else if (e.target.value.length < 6) {
      setPasswordHasError(true);
      setPasswordErrorMessage("Password must be at least 6 characters");
    } else {
      setPasswordHasError(false);
      setPasswordErrorMessage("");
    }
    setPassword(e.target.value);
  };

  const onConfirmPasswordChangeHandler = (e) => {
    if (e.target.value.length === 0) {
      setConfirmHasError(true);
      setConfirmErrorMessage("Confirm password is required");
    } else if (e.target.value !== password) {
      setConfirmHasError(true);
      setConfirmErrorMessage("Password does not match!");
    } else {
      setConfirmHasError(false);
      setConfirmErrorMessage("");
    }
    setConfirmPassword(e.target.value);
  };

  const { token } = useParams();

  const navigate = useNavigate();

  const submitResetPassword = useCallback(
    async (password1) => {
      try {
        setShowLoader(true);
        const res = await resetPassword(token, password1);
        if (res.status) {
          setResponseHasError(false);
          setResponseErrorMessage("");
          navigate("/authentication/sign-in");
        } else {
          setResponseHasError(true);
          setResponseErrorMessage(res.message);
        }
        setShowLoader(false);
      } catch (error) {
        setResponseHasError(true);
        setResponseErrorMessage(error.message);
        setShowLoader(false);
      }
    },
    [token]
  );

  const onSubmitHandler = (e) => {
    e.preventDefault();
    if (passwordHasError) return;
    if (confirmHasError) return;
    if (confirmPassword !== password) {
      setConfirmHasError(true);
      setConfirmErrorMessage("Password does not match!");
      return;
    }
    setConfirmHasError(false);
    setConfirmErrorMessage("");

    submitResetPassword(password);
  };

  return (
    <CoverLayout coverHeight="50vh" image={bgImage}>
      <Card>
        <MDBox
          variant="gradient"
          bgColor="info"
          borderRadius="lg"
          coloredShadow="success"
          mx={2}
          mt={-3}
          py={2}
          mb={1}
          textAlign="center"
        >
          <MDTypography variant="h3" fontWeight="medium" color="white" mt={1}>
            Reset Password
          </MDTypography>
        </MDBox>
        <MDBox pt={4} pb={3} px={3}>
          {responseHasError && (
            <MDTypography variant="h6" fontWeight="medium" color="error">
              {responseErrorMessage}
            </MDTypography>
          )}
          <form onSubmit={onSubmitHandler}>
            <MDBox mb={4}>
              <MDInput
                helperText={passwordErrorMessage}
                error={passwordHasError}
                value={password}
                onChange={onPasswordChangeHandler}
                type="password"
                label="Password"
                variant="standard"
                fullWidth
              />
            </MDBox>
            <MDBox mb={4}>
              <MDInput
                helperText={confirmErrorMessage}
                error={confirmHasError}
                value={confirmPassword}
                onChange={onConfirmPasswordChangeHandler}
                type="password"
                label="Confirm Password"
                variant="standard"
                fullWidth
              />
            </MDBox>
            <MDBox mt={6} mb={1}>
              <MDButton variant="gradient" color="info" fullWidth type="submit">
                reset
              </MDButton>
            </MDBox>
          </form>
        </MDBox>
      </Card>
    </CoverLayout>
  );
}

export default Cover;
